export interface FundRequestColumn {
    key: string;
    label: string;
    sortKey: string;
}

// All available columns for the Fund Request results table.
// Single source of truth shared by FundRequestAccordionItem (picker)
// and FundRequestSearchResults (table).
export const ALL_AVAILABLE_COLUMNS: FundRequestColumn[] = [
    { key: 'id', label: 'Fund Request ID', sortKey: 'id' },
    { key: 'fund_name', label: 'Client Name', sortKey: 'fund_name' },
    { key: 'ntaf_id', label: 'NTAF ID', sortKey: 'ntaf_id' },
    { key: 'ap_invoice_number', label: 'AP Invoice Number', sortKey: 'ap_invoice_number' },
    { key: 'vendor_name', label: 'Payee', sortKey: 'vendor_name' },
    { key: 'request_amount', label: 'Amount', sortKey: 'amount' },
    { key: 'fund_request_status', label: 'Status', sortKey: 'status' },
    { key: 'source', label: 'Source', sortKey: 'source' },
    { key: 'submitted_by', label: 'Submitted By', sortKey: 'submitted_by' },
    { key: 'financial_coordinator', label: 'Coordinator', sortKey: 'coordinator' },
    { key: 'priority', label: 'Priority', sortKey: 'priority' },
    { key: 'created_date', label: 'Created Date', sortKey: 'created_date' },
    { key: 'updated_date', label: 'Updated Date', sortKey: 'updated_date' },
    { key: 'submitted_date', label: 'Submitted Date', sortKey: 'submitted_date' },
    { key: 'had_needs_info', label: 'Had Needs Info', sortKey: 'had_needs_info' },
];

export const DEFAULT_VISIBLE_COLUMNS: string[] = [
    'id',
    'fund_name',
    'ntaf_id',
    'ap_invoice_number',
    'vendor_name',
    'request_amount',
    'fund_request_status',
    'source',
    'created_date',
    'updated_date',
    'had_needs_info',
];

// Parse a `visible_columns` URL value (comma-joined keys) into a validated key list.
// Returns DEFAULT_VISIBLE_COLUMNS when missing or yields no valid keys.
export const parseVisibleColumns = (raw: string | null): string[] => {
    if (raw) {
        const valid = new Set(ALL_AVAILABLE_COLUMNS.map(c => c.key));
        const parsed = raw.split(',').map(s => s.trim()).filter(k => valid.has(k));
        if (parsed.length) return parsed;
    }
    return DEFAULT_VISIBLE_COLUMNS;
};

// True when `selected` is exactly the default set (order-independent).
export const isDefaultSelection = (selected: string[]): boolean =>
    selected.length === DEFAULT_VISIBLE_COLUMNS.length &&
    selected.every(k => DEFAULT_VISIBLE_COLUMNS.includes(k));
